<template>
	<div class="quantificador" :class="!produto.sku ? 'quantificador--centralizado' : ''">
		<button class="produto__botao-diminuir" @click="diminuiItem()"><v-icon>mdi-minus</v-icon></button>
		<input
			class="produto__input-quantidade"
			v-model="qtd"
			@input="validarQuantidade($event)"
			v-mask="produto.venderfracionado ? ['#,##', '##,##', '###,##'] : ['###']"
		/>

		<button class="produto__botao-aumentar" @click="adicionaItem()"><v-icon>mdi-plus</v-icon></button>
	</div>
</template>

<script>
export default {
	props: {
		produto: Object,
		quantidade: [String, Number],
		saldo: [String, Number],
		quantidadeComprada: Number
	},
	data: function () {
		return {
			qtd: this.quantidade,
		}
	},
	methods: {
		async adicionaItem() {
			let quantidade = Number(parseFloat(this.qtd.toString().replace(',', '.')).toFixed(2))

			if (!this.permitirVendaSemEstoque()) {
				if (this.quantidadeComprada + quantidade + 1 <= parseFloat(this.saldo)) quantidade++
			} else if (quantidade < 999) quantidade++

			this.qtd = this.produto.venderfracionado
				? parseFloat(quantidade).toFixed(2).toString().replace('.', ',')
				: parseInt(quantidade)
		},
		diminuiItem() {
			if (this.produto.venderfracionado) {
				if (parseFloat(this.qtd.toString().replace(',', '.')) > 1.0) {
					if (this.qtd.toString().search(',') != -1) {
						this.qtd = this.qtd.replace(',', '.')
					}
					this.qtd--
					this.qtd = parseFloat(this.qtd).toFixed(2).toString().replace('.', ',')
				}
			} else if (this.qtd > 1) {
				this.qtd--
			}
		},
		formatatQuantidade(quantidade) {
			return this.produto.venderfracionado
				? parseFloat(quantidade).toFixed(2).toString().replace('.', ',')
				: parseInt(quantidade)
		},
		alterarQuantidade() {
			this.$emit('alterarQuantidade', this.qtd)
		},
		validarQuantidade(evento) {
			if(!evento.data) {
				let quantidade = Number(parseFloat(this.qtd.toString().replace(',', '.')).toFixed(2))
			if (!this.permitirVendaSemEstoque()) {
				if (quantidade + this.quantidadeComprada > parseFloat(this.saldo)) {
					this.qtd = this.formatatQuantidade(parseFloat(this.saldo)-this.quantidadeComprada)
				}
			}
			}
		},
	},
	watch: {
		qtd() {
			this.alterarQuantidade()
		},
		quantidade(){
			this.qtd = this.quantidade
		}
	},
}
</script>

<style scoped>
.quantificador {
	width: 100%;
	height: 3.7rem;
	background: #d9d9d9;
	border-radius: 13px;
	color: black;
	font-weight: bold;
	font-size: 24px;
	display: flex;
	justify-content: space-around;
	align-items: center;
	text-transform: uppercase;
	margin-bottom: 1rem;
}

.produto__input-quantidade {
	width: 7.875rem;
	height: 2.875rem;
	background: white;
	border-radius: 13px;
	color: black;
	font-weight: bold;
	font-size: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-transform: uppercase;
	border: 2px solid #6d6767;
	text-align: center;
}

input:focus {
	outline: none;
}

.produto__botao-diminuir {
	color: #6d6767;
	outline: none;
}

.produto__botao-diminuir:hover,
.produto__botao-diminuir:focus {
	color: var(--v-primary-base);
}

.produto__botao-aumentar {
	color: #6d6767;
	outline: none;
}

.v-icon {
	color: inherit;
}

.produto__botao-aumentar:hover,
.produto__botao-aumentar:focus {
	color: #008022;
}

@media (max-width: 600px) {
	.quantificador--centralizado {
		margin-top: 0;
	}
}
</style>